import styled from "styled-components";
import { Switch } from "antd";

//STYLES
const SwitchWrapper = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 5px;
    font-size: 13px;
    color: var(--text-color);
`;

//PROPS
interface Props {
    isChecked: boolean;
    trigger: React.Dispatch<React.SetStateAction<boolean>>;
    task?: Function;
    label?: string | React.ReactNode;
    disabled?: boolean;
    size?: 'small'| 'default';
    style?: React.CSSProperties;
    widthSwitch?: number;
}

export const Switcher: React.FC<Props> = ({ isChecked, trigger, label, disabled, task, size, style, widthSwitch }) => {

    return (
        <SwitchWrapper style={style}>
            <Switch 
                checkedChildren="Sim" 
                unCheckedChildren="Não"
                checked={isChecked}
                onChange={()=>{trigger(!isChecked);task?.()}}
                disabled={disabled}
                size={size}
                style={{width: widthSwitch}}
            />
            {!!label &&(
                <>{label}</>
            )}
            
        </SwitchWrapper>
    )
};